import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { apiConfig } from '../../../environments/b2c-config';
import { MsalService } from '@azure/msal-angular';
import { StoreAuthService } from '@app/core/auth/store-auth.service';
import { StoreUserService } from '@app/core/state/store-user.service';
import { DatabaseCacheService } from '../cache/database-cache.service';

@Injectable()
export class CreateFollowUpService {
  headers = new HttpHeaders({
    'Content-Type': 'application/json'
  });

  constructor(
    private httpClient: HttpClient,
    private msalService: MsalService,
    private common: DatabaseCacheService
  ) { }

  createFollowUp(userId, followUpPostBody) {
    let sectionId = this.common.getSelectedSection().sectionId;
    // this.storeAuth.getSection().subscribe((value) => {
    //   if (!value) {
    //     this.sectionId = localStorage.getItem('gokuri.sectionId');
    //   } else {
    //     this.sectionId = value;
    //   }
    // });

    // this.loginUserId = JSON.stringify(this.user.idToken['sub']);

    let user = this.msalService.instance.getActiveAccount();
    let loginUserId = JSON.stringify(user.idTokenClaims['sub']);

    this.headers = this.headers.set('LoginUserId', loginUserId)
      .set('Access-Control-Allow-Origin', '*');

    return this.httpClient.post(`${apiConfig.uri}/licence/${sectionId}/followUps`, followUpPostBody, { headers: this.headers });
  }
}
